import HelpTip from "core/ui/help/HelpTip";
import React, { useEffect, useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";

function MatchSelectGlobal({ matchLevels, loaded, selectionMatching, handleChange }){
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [matchLevel, setMatchLevel] = useState(selectionMatching);

  const getSelectionMatchIcon = (level) => {
    if (!loaded) return "";
    if (!level) { return matchLevels[0].icon; }
    let icon = "";
    if (matchLevels && matchLevels.length > 0) {
      const foundIcon = matchLevels.find(item => {
        return item.value === level;
      }
    );
      icon = (foundIcon?.hasOwnProperty('icon')) ? foundIcon.icon : "";
    }
    return icon;
  }

  const getLabelByValue = (value) => {
    if (!value) return "individual";
    const label = matchLevels.filter(item => item.value === value);
    return label[0] ? label[0].label : "";
  }

  useEffect(() => {
    if(!loaded || !selectionMatching ) return;
    setMatchLevel(selectionMatching);
    // eslint-disable-next-line
  }, [selectionMatching]);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  return (
    <div className="selection-match-level">
      <div className="label">Select Match Level <HelpTip id="selection-match-level" /></div>
      <Dropdown isOpen={dropdownOpen} toggle={toggle}   >
        <DropdownToggle caret><i className={getSelectionMatchIcon(matchLevel)}></i> {getLabelByValue(matchLevel)}</DropdownToggle>
        <DropdownMenu>
          {matchLevels.map((item, index) => (
            <DropdownItem
              onClick={(e) => handleChange(e.target.value)}
              key={item.value}
              id={index}
              value={item.value}
              >
              <i className={item.icon}></i> {item.label}
            </DropdownItem>

          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}

export default MatchSelectGlobal;

